import React from 'react';
import { connect } from 'react-redux';
import { LinearProgress } from 'material-ui';

@connect(store => ({
    loadingbar: store.getIn(['general', 'loadingbar'])
}))
export default class extends React.Component {
  constructor(props){
    super(props);
  }
  render(){
    return(
      <LinearProgress mode="indeterminate" color="#ff3776" className={this.props.loadingbar.get('show') ? 'loadingbar' : 'loadingbar hidden'}/>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/general/components/loadingbar.js